import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { UiFlowConnectorComponent } from '../../atoms/flow-connector/flow-connector.component';
import { UiFlowMarkerComponent } from '../../atoms/flow-marker/flow-marker.component';
import type {
  UiFlowConnectorOrientation,
  UiFlowConnectorStyle,
  UiFlowMarkerTone,
  UiFlowMarkerVariant,
} from '../../shared/flow/flow.types';

@Component({
  selector: 'ui-flow-path',
  standalone: true,
  imports: [UiFlowConnectorComponent, UiFlowMarkerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ui-flow-path" [class]="'ui-flow-path--' + orientation()">
      @if (showMarker()) {
        <ui-flow-marker
          [tone]="marker() ?? 'neutral'"
          [variant]="markerVariant()"
          [tooltipText]="label()"
        />
      }
      <ui-flow-connector
        [orientation]="orientation()"
        [lineStyle]="lineStyle()"
        [arrow]="arrow()"
        [length]="length()"
      />
    </div>
  `,
  styles: `
    :host { display: inline-flex; }
    .ui-flow-path {
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }
    .ui-flow-path--horizontal { flex-direction: row; }
    .ui-flow-path--vertical { flex-direction: column; }
  `,
})
export class UiFlowPathComponent {
  readonly orientation = input<UiFlowConnectorOrientation>('horizontal');
  readonly lineStyle = input<UiFlowConnectorStyle>('solid');
  readonly arrow = input(true);
  readonly length = input('48px');
  readonly marker = input<UiFlowMarkerTone | null>(null);
  readonly markerVariant = input<UiFlowMarkerVariant>('icon');
  /** En variant icon: tooltip. En variant text: texto visible. */
  readonly label = input<string | null>(null);

  protected readonly showMarker = computed(() => {
    if (this.markerVariant() === 'none') return false;
    if (this.markerVariant() === 'text') return !!this.label();
    return this.marker() != null;
  });
}
